module.exports = __webpack_public_path__ + "static/img/squad_template_grey.2dc9600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/squad_template_grey.png
// module id = fGuK
// module chunks = 94